module.exports = __webpack_public_path__ + "static/assets/e9d13287fecd4ec8a75e23fd29161bdc.svg";